<template>
    <svg id="materials" viewBox="0 0 168.8 153.51" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <linearGradient id="a" x1="44.16" x2="198.5" y1="179.78" y2="59.73" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ff34db" offset="0"/>
                <stop stop-color="#f835da" offset=".09"/>
                <stop stop-color="#e537d9" offset=".22"/>
                <stop stop-color="#c63bd6" offset=".37"/>
                <stop stop-color="#9a40d1" offset=".53"/>
                <stop stop-color="#6247cc" offset=".72"/>
                <stop stop-color="#1f4fc6" offset=".91"/>
                <stop stop-color="#0053c3" offset=".99"/>
            </linearGradient>
            <linearGradient id="f" x1="62.66" x2="217.01" y1="203.56" y2="83.51" xlink:href="#a"/>
            <linearGradient id="e" x1="45.22" x2="199.57" y1="181.14" y2="61.09" xlink:href="#a"/>
            <linearGradient id="d" x1="26.34" x2="180.69" y1="156.87" y2="36.82" xlink:href="#a"/>
            <linearGradient id="c" x1="27.89" x2="182.24" y1="158.87" y2="38.82" xlink:href="#a"/>
            <linearGradient id="b" x1="-3.26" x2="151.09" y1="119.11" y2="-.94" xlink:href="#a"/>
        </defs>
        <title>Asset 27</title>
        <g data-name="Layer 2">
            <g data-name="Layer 2">
                <path class="cls-1" d="M158.89,55.47H123a9.91,9.91,0,0,0-9.91,9.91V143.6a9.92,9.92,0,0,0,9.91,9.91h35.86a9.93,9.93,0,0,0,9.91-9.91V65.38A9.92,9.92,0,0,0,158.89,55.47ZM123,60.74h35.86a4.64,4.64,0,0,1,4.64,4.64v67.81H118.39V65.38A4.64,4.64,0,0,1,123,60.74Zm35.86,87.5H123a4.65,4.65,0,0,1-4.64-4.64v-5.14h45.14v5.14A4.65,4.65,0,0,1,158.89,148.24Z"/>
                <path class="cls-2" d="m143 140h-4a2.64 2.64 0 1 0 0 5.27h4a2.64 2.64 0 0 0 0-5.27z"/>
                <path class="cls-3" d="m141.05 126.63a20 20 0 1 0-20-20 20 20 0 0 0 20 20zm14.58-22.08-10.13-1.89 5.15-7.22a14.73 14.73 0 0 1 4.98 9.11zm-14.58-12.68a14.47 14.47 0 0 1 5 0.9l-7.24 10.23a2.64 2.64 0 0 0 1.66 4.12l14.95 2.79a14.74 14.74 0 1 1-14.37-18z"/>
                <path class="cls-4" d="M127.4,72.63h21.28a2.64,2.64,0,1,0,0-5.27H127.4a2.64,2.64,0,0,0,0,5.27Z"/>
                <path class="cls-5" d="m127.4 81.28h7.28a2.64 2.64 0 1 0 0-5.27h-7.28a2.64 2.64 0 0 0 0 5.27z"/>
                <path class="cls-6" d="M138.27,7.66v38a2.64,2.64,0,0,0,5.27,0v-43s0-.06,0-.09a2.33,2.33,0,0,0,0-.37,1.16,1.16,0,0,0,0-.18l0-.15-.06-.14c0-.05,0-.11-.07-.17a1.51,1.51,0,0,0-.15-.28l-.08-.13a2.34,2.34,0,0,0-.29-.35l0,0a2.78,2.78,0,0,0-.32-.26L142.28.4A1.82,1.82,0,0,0,142,.25l-.17-.07a1.49,1.49,0,0,0-.3-.09l-.15,0a2.63,2.63,0,0,0-.49,0H43.57a2.58,2.58,0,0,0-1.49.47L1.16,28.77A2.64,2.64,0,0,0,0,31a2.48,2.48,0,0,0,0,.27V122.4A2.64,2.64,0,0,0,2.64,125H100a2.64,2.64,0,0,0,2.64-2.64V32.33Zm-39.6,21H71.8L102.5,5.27h30ZM42.1,33.92H60.5V55.85H42.1Zm6.26-5.27L80,5.29s0,0,0,0H93.8L63.1,28.65Zm-4-23.38H71.13L39.49,28.65H10.6ZM97.33,119.76H5.27V33.92H36.83V58.48a2.64,2.64,0,0,0,2.64,2.64H63.13a2.64,2.64,0,0,0,2.64-2.64V33.92H97.33Z"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "svg_materials"
    }
</script>

<style lang="scss" scoped>
    #materials{
        .cls-1{fill:url(#a);}
        .cls-2{fill:url(#f);}
        .cls-3{fill:url(#e);}
        .cls-4{fill:url(#d);}
        .cls-5{fill:url(#c);}
        .cls-6{fill:url(#b);}
    }
</style>